module.exports = __webpack_public_path__ + "static/media/north_dakota.a474d324.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/backgrounds/north_dakota.jpg
// module id = 538
// module chunks = 0